import { render, staticRenderFns } from "./LeftSideMenu.vue?vue&type=template&id=72d37270&scoped=true"
import script from "./LeftSideMenu.vue?vue&type=script&lang=js"
export * from "./LeftSideMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftSideMenu.vue?vue&type=style&index=0&id=72d37270&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d37270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d37270')) {
      api.createRecord('72d37270', component.options)
    } else {
      api.reload('72d37270', component.options)
    }
    module.hot.accept("./LeftSideMenu.vue?vue&type=template&id=72d37270&scoped=true", function () {
      api.rerender('72d37270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/LeftSideMenu.vue"
export default component.exports